export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

export const toggleDrawer = () => ({
  type: TOGGLE_DRAWER
});

export const TOGGLE_SWITCH_PUZZLE = 'TOGGLE_SWITCH_PUZZLE';

export const toggleSwitchPuzzle = () => ({
  type: TOGGLE_SWITCH_PUZZLE
});

export const TOGGLE_DELETE_SOLVE_MESSAGE = 'TOGGLE_DELETE_SOLVE_MESSAGE';

export const toggleDeleteSolveMessage = () => ({
  type: TOGGLE_DELETE_SOLVE_MESSAGE
});

export const TOGGLE_LAST_SOLVE_OPTIONS_MENU = 'TOGGLE_LAST_SOLVE_OPTIONS_MENU';

export const toggleLastSolveOptionsMenu = () => ({
  type: TOGGLE_LAST_SOLVE_OPTIONS_MENU
});



// WEBPACK FOOTER //
// ./src/actions/ui.js